import { render } from "./SupervisionDetails.vue?vue&type=template&id=314e640b"
import script from "./SupervisionDetails.vue?vue&type=script&lang=js"
export * from "./SupervisionDetails.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./SupervisionDetails.vue?vue&type=style&index=0&id=314e640b&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__